var map = {
	"./nav-analysis.svg": "SJB+",
	"./nav-archive.svg": "Bzmx",
	"./nav-contract.svg": "Eeck",
	"./nav-cost.svg": "dcxM",
	"./nav-data.svg": "OWeL",
	"./nav-fee.svg": "luYA",
	"./nav-home.svg": "F2S5",
	"./nav-obs.svg": "WN5I",
	"./nav-over.svg": "wTTj",
	"./nav-process.svg": "zLxW",
	"./nav-settlement.svg": "SLpV",
	"./nav-state.svg": "pJiK",
	"./nav-structure.svg": "ZFWB",
	"./nav-taskplan.svg": "Oa7d"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4uVZ";


//////////////////
// WEBPACK FOOTER
// ./src/icons/nav nonrecursive \.svg$
// module id = 4uVZ
// module chunks = 13